<kodit-page>
  <kodit-table [tableConfig]="tableConfig" [items]="pravilaTable" [isTableLoading]="isLoading">
  </kodit-table>
</kodit-page>
